import React, { forwardRef, useEffect, useState } from 'react'
import { useStateValue } from "../StateProvider";
import { ButtonGroup, RadioGroup, Radio, FormControlLabel, Accordion, AccordionDetails, AccordionSummary, Button, CardContent, Grid, Typography, Card, TextField, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, Toolbar } from '@mui/material';
import axios from '../axios';
import StepButtons from '../components/StepButtons';
import { legitEntityArr } from '../helpers/constantVariables'
import Moment from 'react-moment';
import { ExpandMore, Close } from '@mui/icons-material';
import { actionTypes } from '../reducer';
// import { PDFObject } from 'react-pdfobject'
import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { Worker } from '@react-pdf-viewer/core';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Visibility } from '@mui/icons-material';
import { useInput } from "../hooks/inputHook";
import { FormHelperText } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { jsPDF } from "jspdf";
import moment from 'moment';
import logo from '../assets/img/TABNavLogo.webp'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  height: '80%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflow: 'scroll',
};
const style2 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '70%',
  height: '80%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflow: 'scroll',
};

function Confirmation({ },ref) {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [{ applicantDetails, activeStep, hideHauling }, dispatch] = useStateValue();
  const [openOAF, setOpenOAF] = React.useState(false);
  const handleOpenOAF = () => setOpenOAF(true);
  const handleCloseOAF = () => setOpenOAF(false);

  const [openFinancials, setOpenFinancials] = React.useState(false);
  const handleOpenFinancials = () => setOpenFinancials(true);
  const handleCloseFinancials = () => setOpenFinancials(false);

  const [openOAR, setOpenOAR] = React.useState(false);
  const handleOpenOAR = () => setOpenOAR(true);
  const handleCloseOAR = () => setOpenOAR(false);

  const [openConfirm, setOpenConfirm] = React.useState(false);
  const handleOpenConfirm = () => {
    pdfDocView();
    setOpenConfirm(true);
  }
  const handleClosConfirm = () => setOpenConfirm(false);

  const [fileData, setFileData] = useState('');
  const [fileName, setFileName] = useState('');
  const [openAF, setOpenAF] = React.useState(false);
  const handleOpenAF = (file) => {
    setOpenAF(true);
    setFileData(file.data);
    setFileName(file.filename);
  };
  const handleCloseAF = () => setOpenAF(false);

  const [openApplicantForm, setOpenApplicantForm] = useState(false);
  const handleOpenApplicantForm = () => {
    pdfDocView();
    setOpenApplicantForm(true);
  }
  const handleCloseApplicantForm = () => setOpenApplicantForm(false);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const { value: confirmFullName, setValue: setConfirmFullName, bind: bindConfirmFullName } = useInput('');
  const { value: confirmFirst, setValue: setConfirmFirst, bind: bindConfirmFirst } = useInput(null);
  const { value: confirmSecond, setValue: setConfirmSecond, bind: bindConfirmSecond } = useInput(null);
  const { value: confirmThird, setValue: setConfirmThird, bind: bindConfirmThird } = useInput(null);
  const { value: confirmFourth, setValue: setConfirmFourth, bind: bindConfirmFourth } = useInput(null);
  const { value: confirmFifth, setValue: setConfirmFifth, bind: bindConfirmFifth } = useInput(null);
  const { value: confirmSixth, setValue: setConfirmSixth, bind: bindConfirmSixth } = useInput(null);
  const { value: fullNameError, setValue: setFullNameError, bind: bindFullNameError } = useInput(false);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [PDFURL, setPDFURL] = useState();
  const [timestamp, setTimestamp] = useState(null);

   const letters = ['A', 'B', 'C', 'D'];

    const d = new Date();
    let today = d.toLocaleDateString("en-US", { timeZone: 'UTC' });

      const checkData = (data) => {
            return data !== undefined ? `${data}` : ``;
      }
      const undefData = (data) => {
            if (data === undefined) {
                  return "";
            } else {
                  return data;
            }
  }
  
  useEffect(() => {
    if (confirmSecond == "true") {
      setTimestamp(new Date().toISOString());
    }
  
    return () => {
      
    }
  }, [confirmSecond])

  const validateHauling = () => {
    let success = true;
      if (applicantDetails?.truck_to_haul_for == ""
        || applicantDetails?.new_lease == ""
        || applicantDetails?.contact_person == ""
        || applicantDetails?.hauling_phone == ""
        || applicantDetails?.hauling_city == ""
        || applicantDetails?.hauling_state == ""
      ) success = false;
    return success;
  }

//sendequipmentemail
  const createNewApplicant = () => {
    const validHauling = validateHauling();

    if (!hideHauling && !validHauling) {
      dispatch({
        type: actionTypes.SET_SHOW_NOTIFICATION,
        showNotification: {
          show: true,
          title: "Form Validation.",
          content: "Please review the required field(s) in the Hauling reference.",
          success: false
        }
      });
    } else {
      dispatch({
        type: actionTypes.SET_SHOW_PROCESSING,
        showProcessing: {
          show: true,
          title: "Creating New Applicant...",
        },
      });

      const jsonPayload = {
        "applicant": {
          "company_name": applicantDetails?.business_name,
          "tax_id": applicantDetails?.ein,
          "electronic_communications_disclosure": applicantDetails?.electronic_communications_disclosure_agree,
          "beneficial_owners_disclosure": timestamp,
          "overall_application_submission": new Date().toISOString(),
          "is_complete_and_correct": confirmFirst == "true" ? "Yes" : "No",
          "individual_with_control": confirmSecond == "true" ? "Yes" : "No",
          "tax_id_correct": confirmThird == "true" ? "Yes" : "No",
          "application_disclosure": confirmFifth == "true" ? "Yes" : "No",
        }
      }

      var formData = new FormData();
      formData.append("applicant_file", pdfBlob, "Application_Form.pdf");
      Object.keys(applicantDetails?.additional_invoice_payload).forEach((index) => {
        formData.append("invoice_files", applicantDetails?.additional_invoice_payload[index]);
      });
      Object.keys(applicantDetails?.additional_vs_payload).forEach((index) => {
        formData.append("vehicle_files", applicantDetails?.additional_vs_payload[index]);
      });
      Object.keys(applicantDetails?.additional_dl_payload).forEach((index) => {
        formData.append("driver_license_files", applicantDetails?.additional_dl_payload[index]);
      });
      Object.keys(applicantDetails?.additional_docs_payload).forEach((index) => {
        formData.append("other_docs_files", applicantDetails?.additional_docs_payload[index]);
      });

      formData.append("onlineApplicant", JSON.stringify(jsonPayload));

      axios.post("/api/send_equipment_applicant/", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          if (response.status === 200) {
            localStorage.clear();
            dispatch({
              type: actionTypes.SET_SHOW_PROCESSING,
              showProcessing: {
                show: false,
                title: "Success...",
              },
            });
            dispatch({
              type: actionTypes.SET_ACTIVE_STEP,
              activeStep: activeStep + 1,
            });

          } else {
            // console.log(response);
            dispatch({
              type: actionTypes.SET_SHOW_PROCESSING,
              showProcessing: {
                show: false,
                title: "Something went wrong...",
              },
            });
            dispatch({
              type: actionTypes.SET_SHOW_NOTIFICATION,
              showNotification: {
                show: true,
                title: "Error",
                content: "Something went wrong...",
                success: false
              }
            });
          }
        }).catch(err => {
          if (err.response && err.response.status === 413) {
            dispatch({
              type: actionTypes.SET_SHOW_NOTIFICATION,
              showNotification: {
                show: true,
                title: "Check File Upload.",
                content: "Please check your documents, file(s) might be too large.",
                success: false
              }
            });
          } else {
            dispatch({
              type: actionTypes.SET_SHOW_PROCESSING,
              showProcessing: {
                show: false,
                title: "Something went wrong...",
              },
            });
            dispatch({
              type: actionTypes.SET_SHOW_NOTIFICATION,
              showNotification: {
                show: true,
                title: "Error",
                content: "Something went wrong...",
                success: false
              }
            });
          }
        });
    }
  }

  const onUpdateDocumentsInfo = () => {
  }
  const AdditionalInvoiceFilesConf = applicantDetails?.additional_invoice_files;
  const AdditionalVSFilesConf = applicantDetails?.additional_vs_files;
  const AdditionalDLFilesConf = applicantDetails?.additional_dl_files;
  const AdditionalDocsFilesConf = applicantDetails?.additional_docs_files;
  //console.log("invoicedocs",AdditionalInvoiceFilesConf)

  if (applicantDetails?.operating_agreement) {
    var OperatingAgreementFile = applicantDetails?.operating_agreement.match(/[^\\/]*$/)[0];
  } else {
    var OperatingAgreementFile = "";
  }

  if (applicantDetails?.financials) {
    var FinancialFile = applicantDetails?.financials.match(/[^\\/]*$/)[0];
  } else {
    var FinancialFile = "";
  }

  if (applicantDetails?.open_ar) {
    var OpenARFile = applicantDetails?.open_ar.match(/[^\\/]*$/)[0];
  } else {
    var OpenARFile = "";
  }

  const handleChecker = () => {
    setFullNameError(nameChecker);
  }

  const nameChecker = () => {
    var owners = applicantDetails?.owners;
    for (var i = 0; i < owners.length; i++) {
      if (owners[i].first_name.toLowerCase() == (confirmFullName.split(" ")[0])?.toLowerCase() && owners[i].last_name.toLowerCase() == (confirmFullName.split(" ")[1])?.toLowerCase()) {
        return true;
      }
      if ((confirmFullName?.toLowerCase().replace(/\s{2,}/g, " ")).includes(owners[i].first_name.toLowerCase().replace(/\s{2,}/g, " ")) && (confirmFullName?.toLowerCase().replace(/\s{2,}/g, " ")).includes(owners[i].last_name.toLowerCase().replace(/\s{2,}/g, " "))) {
        return true;
      }
    }
  }

  const formatNumberWithCommas = (num,dollar=false) => {
    return num != "" && num != undefined ? (dollar ? "$" : "") + new Intl.NumberFormat().format(num) : "";
  };

  const pdfDocView = () => {
    const doc = new jsPDF({
      orientation: 'p',
      unit: 'pt',
      format: 'letter'
    });
    const marginLeft = 50;
    const maxWidth = 510;

    var img = new Image();
    var dataURL;
    img.src = require('../assets/img/noaLogo.png');
    img.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      var context = canvas.getContext('2d');
      context.drawImage(img, 0, 0);

      dataURL = canvas.toDataURL('image/png');

      return dataURL;
    }
    
    let control_owner = [];
    for (let i = 0; i < letters.length; i++) {
      if (applicantDetails?.owners[i]?.control_owner === true && i === 0) control_owner  = applicantDetails?.owners[i]
    }
        
    doc.setFontSize(10)
    doc.setFont('Helvetica', 'bold');
    doc.text("EQUIPMENT CREDIT FINANCING APPLICATION", marginLeft, 60);
    doc.setFontSize(10)
    doc.setFont('Helvetica', 'bolditalic');
    doc.text("and", marginLeft, 72);
    doc.setFontSize(10)
    doc.setFont('Helvetica', 'bold');
    doc.text("BENEFICIAL OWNER", marginLeft + 23, 72);
    doc.setFontSize(6)
    doc.text("Please return completed applications to TAB Bank, Equipment Department", marginLeft, 91);
    doc.text("For questions, call toll-free (800) 355-3063 or visit us at www.tabbank.com", marginLeft, 99);

    doc.addImage(img, 360, 30);
    doc.setFontSize(6)
    doc.setFont('Helvetica', '', 'bold');
    doc.text("4185 Harrison Blvd., Ogden, UT 84403", 370, 91);
    doc.text("Fax: (801) 624-5215      E-mail: yellowteam.sme@tabbank.com", 370, 99);
       
      let formY = 114;
      
        doc.setFillColor(0,0,0);
        doc.rect(marginLeft, formY, maxWidth, 1, "F");
        doc.setFillColor(146,208,80);
        doc.rect(marginLeft, formY + 1, maxWidth, 13, "F");
        doc.setFillColor(0, 0, 0);
        doc.rect(marginLeft, formY + 13, maxWidth, 1, "F");
        doc.setFontSize(10)
        doc.text("COMPANY INFORMATION", marginLeft + 2, formY + 11);
      
        doc.setFontSize(7.5);
      doc.setFont('Helvetica', '', 'normal');
      
        doc.text("Legal Business Name:", marginLeft + 2, formY + 23.5);
        doc.text(applicantDetails?.business_name, marginLeft + 85, formY + 23.5);
        doc.text("Federal Tax ID#:", marginLeft + 320, formY + 23.5);
        doc.text(applicantDetails?.ein, marginLeft + 380, formY + 23.5);
        doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 25, maxWidth, 1, "F");

      doc.text("DBA:", marginLeft + 2, formY + 36.5);
      doc.text(applicantDetails?.dba, marginLeft + 27, formY + 36.5);
      doc.text("Nature of Business:", marginLeft + 160, formY + 36.5);
      doc.text("State Tax ID#:", marginLeft + 320, formY + 36.5);
      doc.text(applicantDetails?.ein, marginLeft + 375, formY + 36.5);
        doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 38, maxWidth, 1, "F");

      doc.text("Physical Address:", marginLeft + 2, formY + 49.5);
      doc.text(applicantDetails?.address1, marginLeft + 70, formY + 49.5);
      doc.text("City:", marginLeft + 290, formY + 49.5);
      doc.text(applicantDetails?.city, marginLeft + 312, formY + 49.5);
      doc.text("State:", marginLeft + 380, formY + 49.5);
      doc.text(applicantDetails?.state, marginLeft + 405, formY + 49.5);
      doc.text("Zip:", marginLeft + 450, formY + 49.5);
      doc.text(applicantDetails?.zipcode, marginLeft + 470, formY + 49.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 51, maxWidth, 1, "F");

      doc.text("Mailing Address:", marginLeft + 2, formY + 62.5);
      doc.text(control_owner?.mail_address1, marginLeft + 70, formY + 62.5);
      doc.text("City:", marginLeft + 290, formY + 62.5);
      doc.text(control_owner?.mail_city, marginLeft + 312, formY + 62.5);
      doc.text("State:", marginLeft + 380, formY + 62.5);
      doc.text(control_owner?.mail_state, marginLeft + 405, formY + 62.5);
      doc.text("Zip:", marginLeft + 450, formY + 62.5);
      doc.text(control_owner?.mail_zipcode, marginLeft + 470, formY + 62.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 64, maxWidth, 1, "F");
      
      doc.text("Garaging Address:", marginLeft + 2, formY + 75.5);
      doc.text(control_owner?.garage_address1, marginLeft + 70, formY + 75.5);
      doc.text("City:", marginLeft + 290, formY + 75.5);
      doc.text(control_owner?.garage_city, marginLeft + 312, formY + 75.5);
      doc.text("State:", marginLeft + 380, formY + 75.5);
      doc.text(control_owner?.garage_state, marginLeft + 405, formY + 75.5);
      doc.text("Zip:", marginLeft + 450, formY + 75.5);
      doc.text(control_owner?.garage_zipcode, marginLeft + 470, formY + 75.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 77, maxWidth, 1, "F");

      doc.text("Contact Phone:", marginLeft + 2, formY + 88.5);
      doc.text(applicantDetails?.phone+` / `+applicantDetails?.mobile, marginLeft + 60, formY + 88.5);
      doc.text("Fax:", marginLeft + 200, formY + 88.5);
      doc.text("Email:", marginLeft + 320, formY + 88.5);
      doc.text(applicantDetails?.email, marginLeft + 345, formY + 88.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 90, maxWidth, 1, "F");
      
      doc.text("CDL/Driver's License #:", marginLeft + 2, formY + 101.5);
      doc.text("State Issued:", marginLeft + 195, formY + 101.5);
      doc.text("MC/DOT#:", marginLeft + 340, formY + 101.5);
      doc.text(`${applicantDetails?.isMcAuthority === "true" ? applicantDetails?.businessinfo_mc : ""}`, marginLeft + 382, formY + 101.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 103, maxWidth, 1, "F");

      doc.text("Year Established:", marginLeft + 2, formY + 114.5);
      doc.text(`${moment(checkData(applicantDetails?.year_established)).year()}`, marginLeft + 67, formY + 114.5);
      doc.text("Years Driving:", marginLeft + 185, formY + 114.5);
      doc.text("Years as Owner:", marginLeft + 310, formY + 114.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 116, maxWidth, 1, "F");

      doc.text("Business Structure:", marginLeft + 2, formY + 127.5);
      doc.rect(marginLeft + 100, formY + 122, 5, 5, applicantDetails?.legit_entity == 'GP' ? "F" : "S");
      doc.text("Partnership", marginLeft + 107, formY + 127.5);
      doc.rect(marginLeft + 180, formY + 122, 5, 5, applicantDetails?.legit_entity == 'LLC' ? "F" : "S");
      doc.text("Limited Liability Corp.", marginLeft + 187, formY + 127.5);
      doc.rect(marginLeft + 300, formY + 122, 5, 5, applicantDetails?.legit_entity == 'Sole' ? "F" : "S");
      doc.text("Sole Proprietor", marginLeft + 307, formY + 127.5);
      doc.rect(marginLeft + 400, formY + 122, 5, 5, applicantDetails?.legit_entity == 'Corp' ? "F" : "S");
      doc.text("Corporation", marginLeft + 407, formY + 127.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 129, maxWidth, 1, "F");

      doc.text("Website Address:", marginLeft + 2, formY + 140.5);
      doc.text("Total Number of Employees:", marginLeft + 170, formY + 140.5);
      doc.text("Number of Vehicles in Fleet: (trucking  only)", marginLeft + 315, formY + 140.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 142, maxWidth, 1, "F");
      
      doc.setFontSize(7.5);
      doc.setFont('Helvetica', '', 'normal');
      doc.text("Have you ever financed a truck/trailer?", marginLeft + 2, formY + 153.5);
      doc.text("Yes", marginLeft + 170, formY + 153.5);
      doc.rect(marginLeft + 187, formY + 148.5, 5, 5, (applicantDetails?.is_transportation == 'true') ? (applicantDetails?.is_financed == 'true' ? "F" : "S") : "S");
      doc.text("No", marginLeft + 210, formY + 153.5);
      doc.rect(marginLeft + 224, formY + 148.5, 5, 5, (applicantDetails?.is_transportation == 'true') ? (applicantDetails?.is_financed == 'false' ? "F" : "S") : "S");
      doc.text("Is this purchase a:", marginLeft + 290, formY + 153.5);
      doc.rect(marginLeft + 373, formY + 148.5, 5, 5, (applicantDetails?.is_transportation == 'true') ? (applicantDetails?.is_purchase == 'replacement' ? "F" : "S") : "S");
      doc.text("Replacement", marginLeft + 380, formY + 153.5);
      doc.rect(marginLeft + 453, formY + 148.5, 5, 5, (applicantDetails?.is_transportation == 'true') ? (applicantDetails?.is_purchase == 'addition' ? "F" : "S") : "S");
      doc.text("Addition", marginLeft + 460, formY + 153.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 155, maxWidth, 1, "F");
          
      doc.text("Fleet Size -", marginLeft + 2, formY + 166.5);
      doc.text(`${applicantDetails?.is_transportation == 'true' ? applicantDetails?.fleet_size : ""}`, marginLeft + 42, formY + 166.5);
      doc.text("Number of Trucks:", marginLeft + 60, formY + 166.5);
      doc.text(`${applicantDetails?.is_transportation == 'true' ? applicantDetails?.number_of_trucks : ""}`, marginLeft + 127, formY + 166.5);
      doc.text("Number of Trailers:", marginLeft + 260, formY +166.5);
      doc.text(`${applicantDetails?.is_transportation == 'true' ? applicantDetails?.number_of_trailers : ""}`, marginLeft + 330, formY +166.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 168, maxWidth, 1, "F");
          
      formY += 100;
      
          let has_declared_bankruptcy = 0;
          let has_been_defendant_of_any_legal_action = 0;
          let had_an_item_repossessed = 0;
          for (let i = 0; i < letters.length; i++) {
                if (applicantDetails?.owners[i]?.declared_bankruptcy === "true") has_declared_bankruptcy += 1;
                if (applicantDetails?.owners[i]?.defendant_legal === "true") has_been_defendant_of_any_legal_action += 1;
                if (applicantDetails?.owners[i]?.item_repossessed === "true") had_an_item_repossessed += 1;
            formY += 69;
            doc.setFillColor(146,208,80);
            doc.rect(marginLeft, formY, maxWidth, 13, "F");
            doc.setFillColor(0, 0, 0);
            doc.rect(marginLeft, formY + 13, maxWidth, 1, "F");
            doc.setFont('Helvetica', '', 'bold');
            doc.setFontSize(10)
            doc.text(`[`+letters[i]+`]`, marginLeft + 2, formY + 11);
            doc.setFont('Helvetica', 'italic', 'bold');
            doc.text("Business Owner/Authorized Signer/Guarantor/Beneficial Owner Information", marginLeft + 17, formY + 11);

            doc.setFontSize(7.5);
            doc.setFont('Helvetica', '', 'normal');
            doc.text("First Name:", marginLeft + 2, formY + 22.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.first_name)}`, marginLeft + 50, formY + 22.5);
            doc.text("Last Name:", marginLeft + 265, formY + 22.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.last_name)}`, marginLeft + 312, formY + 22.5);
            doc.setFillColor(0, 0, 0);
            doc.rect(marginLeft, formY + 24, maxWidth, 1, "F");
            doc.text("Social Security #:", marginLeft + 2, formY + 33.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.ssn)}`, marginLeft + 67, formY + 33.5);
            doc.text("Position /Title:", marginLeft + 220, formY + 33.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.title)}`, marginLeft + 275, formY + 33.5);
            doc.text("Date of Birth:", marginLeft + 350, formY + 33.5);
            doc.text(`${applicantDetails?.owners[i]?.date_of_birth != undefined ? moment(checkData(applicantDetails?.owners[i]?.date_of_birth)).format('MM/DD/YYYY') : ""}`, marginLeft + 400, formY + 33.5);
            doc.setFillColor(0, 0, 0);
            doc.rect(marginLeft, formY + 35, maxWidth, 1, "F");
            doc.text("CDL/Driver's License #:", marginLeft + 2, formY + 44.5);
            doc.text("State:", marginLeft + 210, formY + 44.5);
            doc.text("Expiration:", marginLeft + 295, formY + 44.5);
            doc.setFillColor(0, 0, 0);
            doc.rect(marginLeft, formY + 46, maxWidth, 1, "F");
            doc.text("Email:", marginLeft + 2, formY + 55.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.email)}`, marginLeft + 30, formY + 55.5);
            doc.text("Mobile Phone:", marginLeft + 220, formY + 55.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.home_phone)}`, marginLeft + 275, formY + 55.5);
            if(applicantDetails?.owners[i]?.mobile_phone) doc.text(`/ ${checkData(applicantDetails?.owners[i]?.mobile_phone)}`, marginLeft + 330, formY + 55.5);
            doc.text("Ownership %:", marginLeft + 400, formY + 55.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.ownership_percent)}`, marginLeft + 452, formY + 55.5);
            doc.setFillColor(0, 0, 0);
            doc.rect(marginLeft, formY + 57, maxWidth, 1, "F");
            doc.text("Residence/Physical Address:", marginLeft + 2, formY + 66.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.phys_address1)}`, marginLeft + 105, formY + 66.5);
            doc.text("City:", marginLeft + 275, formY + 66.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.phys_city)}`, marginLeft + 295, formY + 66.5);
            doc.text("State:", marginLeft + 375, formY + 66.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.phys_state)}`, marginLeft + 400, formY + 66.5);
            doc.text("Zip:", marginLeft + 450, formY + 66.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.phys_zipcode)}`, marginLeft + 467, formY + 66.5);
            doc.setFillColor(0, 0, 0);
            doc.rect(marginLeft, formY + 68, maxWidth, 1, "F");
            /* doc.text("Mailing Address:", marginLeft + 2, formY + 79.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.mail_address1)}`, marginLeft + 105, formY + 79.5);
            doc.text("City:", marginLeft + 275, formY + 79.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.mail_city)}`, marginLeft + 295, formY + 79.5);
            doc.text("State:", marginLeft + 375, formY + 79.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.mail_state)}`, marginLeft + 400, formY + 79.5);
            doc.text("Zip:", marginLeft + 450, formY + 79.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.mail_zipcode)}`, marginLeft + 467, formY + 79.5);
            doc.setFillColor(0, 0, 0);
            doc.rect(marginLeft, formY + 81, maxWidth, 1, "F");
            doc.text("Garaging Address:", marginLeft + 2, formY + 92.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.garage_address1)}`, marginLeft + 105, formY + 92.5);
            doc.text("City:", marginLeft + 275, formY + 92.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.garage_city)}`, marginLeft + 295, formY + 92.5);
            doc.text("State:", marginLeft + 375, formY + 92.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.garage_state)}`, marginLeft + 400, formY + 92.5);
            doc.text("Zip:", marginLeft + 450, formY + 92.5);
            doc.text(`${checkData(applicantDetails?.owners[i]?.garage_zipcode)}`, marginLeft + 467, formY + 92.5);
            doc.setFillColor(0, 0, 0);
            doc.rect(marginLeft, formY + 94, maxWidth, 1, "F"); */
      }

      formY += 68;
      doc.setFillColor(146,208,80);
      doc.rect(marginLeft, formY + 1, maxWidth, 13, "F");
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 13, maxWidth, 1, "F");
      doc.setFont('Helvetica', '', 'bold');
      doc.setFontSize(10)
      doc.text("Other Important Information", marginLeft + 2, formY + 11);

      doc.setFontSize(7.5);
      doc.setFont('Helvetica', '', 'normal');
      doc.text("Has the individual or entity associated with this application ever:", marginLeft + 2, formY + 22.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 24, maxWidth, 1, "F");
      doc.text("Declared bankruptcy?", marginLeft + 2, formY + 33.5);
      doc.text("Yes", marginLeft + 300, formY + 33.5);
      doc.rect(marginLeft + 317, formY + 28.5, 5, 5, has_declared_bankruptcy > 0 ? "F" : "S");
      doc.text("No", marginLeft + 350, formY + 33.5);
      doc.rect(marginLeft + 364, formY + 28.5, 5, 5, has_declared_bankruptcy < 1 ? "F" : "S");
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 35, maxWidth, 1, "F");
      doc.text("Been a defendant in any legal action?", marginLeft + 2, formY + 44.5);
      doc.text("Yes", marginLeft + 300, formY + 44.5);
      doc.rect(marginLeft + 317, formY + 39.5, 5, 5, has_been_defendant_of_any_legal_action > 0 ? "F":"S");
      doc.text("No", marginLeft + 350, formY + 44.5);
      doc.rect(marginLeft + 364, formY + 39.5, 5, 5, has_been_defendant_of_any_legal_action < 1 ? "F":"S");
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 46, maxWidth, 1, "F");
      doc.text("Ever had an item repossessed?", marginLeft + 2, formY + 55.5);
      doc.text("Yes", marginLeft + 300, formY +55.5);
      doc.rect(marginLeft + 317, formY + 50.5, 5, 5, had_an_item_repossessed > 0 ? "F":"S");
      doc.text("No", marginLeft + 350, formY + 55.5);
      doc.rect(marginLeft + 364, formY + 50.5, 5, 5, had_an_item_repossessed < 1 ? "F":"S");
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 57, maxWidth, 1, "F");
      //doc.setFillColor(0, 0, 0);
      //doc.rect(marginLeft, formY + 70, maxWidth, 1, "F");

      formY += 57;
      doc.setFillColor(146,208,80);
      doc.rect(marginLeft, formY + 1, maxWidth, 13, "F");
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 13, maxWidth, 1, "F");
      doc.setFont('Helvetica', '', 'bold');
      doc.setFontSize(10)
      doc.text("Hauling Reference/Major Customer", marginLeft + 2, formY + 11);

      doc.setFontSize(7.5);
      doc.setFont('Helvetica', '', 'normal');
      doc.text("Truck to Haul For:", marginLeft + 2, formY + 22.5);
      doc.text(`${applicantDetails?.truck_to_haul_for}`, marginLeft + 67, formY + 22.5);
      doc.text("New Lease:", marginLeft + 240, formY + 22.5);
      doc.text("Yes", marginLeft + 300, formY + 22.5);
      doc.rect(marginLeft + 317, formY + 17.5, 5, 5, `${applicantDetails?.isMcAuthority != "true" && applicantDetails?.new_lease === "true" ? "F":"S"}`);
      doc.text("No", marginLeft + 330, formY + 22.5);
      doc.rect(marginLeft + 343, formY + 17.5, 5, 5, `${applicantDetails?.isMcAuthority != "true" && applicantDetails?.new_lease === "false" ? "F":"S"}`);
      doc.text("Years with Company?", marginLeft + 390, formY + 22.5);
      doc.text(`${applicantDetails?.years_with_company}`, marginLeft + 467, formY + 22.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 24, maxWidth, 1, "F");
      doc.text("Phone:", marginLeft + 2, formY + 33.5);
      doc.text(`${applicantDetails?.hauling_phone}`, marginLeft + 32, formY + 33.5);
      doc.text("Contact:", marginLeft + 150, formY + 33.5);
      doc.text(`${applicantDetails?.contact_person}`, marginLeft + 182, formY + 33.5);
      doc.text("Monthly Gross Income:", marginLeft + 310, formY + 33.5);
      doc.text(`${formatNumberWithCommas(applicantDetails?.monthly_gross_income,true)}`, marginLeft + 392, formY + 33.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 35, maxWidth, 1, "F");
      doc.text("Commodity Hauled:", marginLeft + 2, formY + 44.5);
      doc.text(`${applicantDetails?.commodity_hauled}`, marginLeft + 75, formY + 44.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 46, maxWidth, 1, "F");
      doc.text("Address:", marginLeft + 2, formY + 55.5);
      doc.text(`${applicantDetails?.hauling_address}`, marginLeft + 37, formY + 55.5);
      doc.text("City:", marginLeft + 275, formY + 55.5);
      doc.text(`${applicantDetails?.hauling_city}`, marginLeft + 295, formY + 55.5);
      doc.text("State:", marginLeft + 375, formY + 55.5);
      doc.text(`${applicantDetails?.hauling_state}`, marginLeft + 400, formY + 55.5);
      doc.text("Zip:", marginLeft + 450, formY + 55.5);
      doc.text(`${applicantDetails?.hauling_zipcode}`, marginLeft + 467, formY + 55.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 57, maxWidth, 1, "F");
      
      formY += 57;
      doc.setFillColor(146,208,80);
      doc.rect(marginLeft, formY + 1, maxWidth, 13, "F");
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 13, maxWidth, 1, "F");
      doc.setFont('Helvetica', '', 'bold');
      doc.setFontSize(10)
      doc.text("Equipment", marginLeft + 2, formY + 11);
      
      doc.setFontSize(7.5);
      doc.setFont('Helvetica', '', 'normal');
          for (let i = 0; i < 3; i++) {
                formY += 13;
                doc.text("Equipment:", marginLeft + 2, formY + 11.5);
                doc.text(`${undefData(applicantDetails?.equipments[i]?.equip_type)}`, marginLeft + 50, formY + 11.5);
                doc.text("Invoice Amount:", marginLeft + 200, formY + 11.5);
                doc.text(`${formatNumberWithCommas(applicantDetails?.equipments[i]?.equip_inv_amount,true)}`, marginLeft + 260, formY + 11.5);
                doc.setFillColor(0, 0, 0);
                doc.rect(marginLeft, formY + 13, maxWidth, 1, "F");
          }

      doc.addPage();

      formY = 50;
      doc.setFillColor(224, 226, 228);
      doc.rect(marginLeft, formY + 1, maxWidth, 13, "F");
      doc.setFont('Helvetica', '', 'bold');
      doc.setFontSize(8.5)
      doc.text("Are you a Money Service Business (MSB)?", marginLeft + 2, formY + 11);
      doc.text("Yes", marginLeft + 220, formY + 11);
      doc.rect(marginLeft + 239, formY + 6, 5, 5, applicantDetails?.is_money_service === "true" ? "F":"S");
      doc.text("No", marginLeft + 270, formY + 11);
      doc.rect(marginLeft + 285, formY + 6, 5, 5, applicantDetails?.is_money_service === "false" ? "F":"S");
      doc.setFont('Helvetica', 'italic', 'bold');
      doc.setFontSize(7.5)
      doc.text(`You may be considered an MSB if you:`, marginLeft + 30, formY + 22);
      doc.setFont('Helvetica', '', 'normal');
      doc.text(`(1) Provide check cashing services or other monetary instruments in an amount greater`, marginLeft + 175, formY + 22);
      doc.setFont('Helvetica', '', 'normal');
      doc.text(`
than $1,000 for any person on any day in one or more transactions. (2) Provide money transmission services. (3) Issue or Sell
Travelers Checks or Money Orders in an amount greater than $1,000 to any person on any day in one or more transactions. (4)
Accept the currency or other monetary instruments of one or more countries in exchange for the currency of one or more other
countries in an amount greater than $1,000 for any person on any day in one or more transactions. (5) Provide or Sell Prepaid`, marginLeft + 30, formY + 22);
      
      formY += 60;
      doc.setFillColor(224, 226, 228);
      doc.rect(marginLeft, formY + 1, maxWidth, 13, "F");
      doc.setFont('Helvetica', '', 'bold');
      doc.setFontSize(8.5)
      doc.text("Is any company officer, applicant, cardholder (driver) or guarantor a politically exposed person?", marginLeft + 2, formY + 11);
      doc.text("Yes", marginLeft + 410, formY + 11);
      doc.rect(marginLeft + 429, formY + 6, 5, 5, applicantDetails?.politically_exposed === "true" ? "F":"S");
      doc.text("No", marginLeft + 450, formY + 11);
      doc.rect(marginLeft + 465, formY + 6, 5, 5, applicantDetails?.politically_exposed === "false" ? "F":"S");
      doc.setFont('Helvetica', '', 'bold');
      doc.setFontSize(7.5)
      doc.text(`Politically exposed person`, marginLeft + 30, formY + 22);
      doc.setFont('Helvetica', '', 'normal');
      doc.text(`or`, marginLeft + 127, formY + 22);
      doc.setFont('Helvetica', '', 'bold');
      doc.text(`PEP`, marginLeft + 136, formY + 22);
      doc.setFont('Helvetica', '', 'normal');
      doc.text(`is a current or former senior foreign political figure, their immediate family, and their close`, marginLeft + 154, formY + 22);
      doc.text(`associates. Such an individual must be tracked by financial institutions as they pose potential reputational risk to regulated entities.`, marginLeft + 30, formY + 30);

      formY += 35;
      doc.setFillColor(224, 226, 228);
      doc.rect(marginLeft, formY + 1, maxWidth, 13, "F");
      doc.setFont('Helvetica', '', 'bold');
      doc.setFontSize(8.5);
      doc.text("Is this Business involved with Internet Gambling?", marginLeft + 2, formY + 11);
      doc.text("Yes", marginLeft + 240, formY + 11);
      doc.rect(marginLeft + 259, formY + 6, 5, 5, applicantDetails?.is_gambling === "true" ? "F":"S");
      doc.text("No", marginLeft + 290, formY + 11);
      doc.rect(marginLeft + 305, formY + 6, 5, 5, applicantDetails?.is_gambling === "false" ? "F":"S");
      doc.setFontSize(7.5);
      doc.setFont('Helvetica', '', 'normal');
      doc.text(`Certain transactions are prohibited from being processed through your prepaid card or other relationship with TAB Bank under the
Unlawful Internet Gambling Enforcement Act of 2006 (“Act”) and related regulations that have been issued by the Board of
Governors of the Federal Reserve System and the United States Department Of The Treasury (“Regulation GG”). TAB Bank is also
required by the Act and Regulation GG to inform its commercial customers of this restriction. The transactions which are prohibited
are the following transactions or transmittals involving any credit, funds, instrument or proceeds that the Act prohibits any person
engaged in the business of betting or wagering (except for the activities of a financial transaction provider, or any interactive
computer service or telecommunications service) from knowingly accepting, in connection with the participation of another person in
unlawful Internet Gambling: (1) Credit, or the proceeds of credit, extended to or on behalf of such person (including credit extended
through the use of a credit card); (2) An electronic fund transfer, or funds transmitted by or through a money transmitting business, or
the proceeds of an electronic fund transfer or money transmitting service, from or on behalf of such other person; (3) Any check,
draft, or similar instrument that is drawn on a payable at or through any financial institution.
Internet gambling will generally be deemed to be unlawful unless it is expressly authorized by license issued by an appropriate State
or Tribalauthority. Please let us know if you have any license issued by an appropriate State or Tribal authority. Please let us know if
you have any questions.`, marginLeft + 30, formY + 22);
      
      formY += 140;
      doc.setFillColor(224, 226, 228);
      doc.rect(marginLeft, formY + 1, maxWidth, 13, "F");
      doc.setFont('Helvetica', '', 'bold');
      doc.setFontSize(8.5);
      doc.text("Where does your business operate?", marginLeft + 2, formY + 11);
      doc.setFontSize(7.5);
      doc.setFont('Helvetica', '', 'normal');
      doc.text("Within USA", marginLeft + 155, formY + 11);
      doc.rect(marginLeft + 195, formY + 6, 5, 5);
      doc.text("USA and Canada", marginLeft + 215, formY + 11);
      doc.rect(marginLeft + 275, formY + 6, 5, 5);
      doc.text("USA and Mexico", marginLeft + 295, formY + 11);
      doc.rect(marginLeft + 353, formY + 6, 5, 5);
      doc.text("Other", marginLeft + 375, formY + 11);
      doc.rect(marginLeft + 396, formY + 6, 5, 5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft + 396, formY + 13, 100, 0.5, "F");
      doc.text(`By executing this application, the undersigned certifies to the following: The information set forth in this application and in the documents, schedules,
reports, statements, and / or other information provided to TAB Bank with or pursuant to this application are full, true, correct, and complete and
accurately reflect such information on the date(s) thereof; that TAB Bank is authorized to request, receive, and verify credit reports and other
financial information regarding applicant and its business applicant and its owners/officers that TAB Bank deems necessary and appropriate; that
TAB Bank is authorized to execute in the name of the Business and the undersigned person(s) and file against the Business and undersigned person(s)
in favor of TAB Bank financing statements with respect to the Business and undersigned person(s) assets; and that TAB Bank is authorized to inquire of,
investigate, confirm, and verify any information contained in this application, in any documents, schedules, reports, statements, and / or other
information provided under or pursuant to this application and the subsequent maintenance and review of any account opened as a result of this
application, or learned by TAB Bank as part of its investigation and review IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING
A NEW BUSINESS ACCOUNT- To help the government fight the funding of terrorism and money laundering activities, federal law requires all financial
institutions to obtain, verify, and record information that identifies each person who applies for an account. What this means for you: When you apply
for an account, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see
your driver's license, social security card, or other identifying documents.`, marginLeft + 2, formY + 22);
          
      formY += 86;
      for (let i = 0; i < letters.length; i++) {
            formY += 43;
            doc.setFillColor(0, 0, 0);
            doc.rect(marginLeft, formY, maxWidth, 1, "F");
            doc.setFillColor(146,208,80);
            doc.rect(marginLeft, formY + 1, maxWidth, 11, "F");
            doc.setFillColor(0, 0, 0);
            doc.rect(marginLeft, formY + 11, maxWidth, 1, "F");
            doc.setFont('Helvetica', '', 'bold');
            doc.setFontSize(8.5)
            doc.text(`[`+letters[i]+`]`, marginLeft + 2, formY + 9.5);
            doc.setFont('Helvetica', 'italic', 'bold');
            doc.text("Business Owner/Authorized Signer/Guarantor/Beneficial Owner Information", marginLeft + 17, formY + 9.5);
            doc.setFontSize(7.5);
            doc.setFont('Helvetica', '', 'bold');
            doc.text("X", marginLeft + 20, formY + 22);
            doc.setFillColor(0, 0, 0);
            doc.rect(marginLeft + 26, formY + 23, maxWidth - 26, 1, "F");
            doc.setFont('Helvetica', '', 'normal');
            doc.text("Date", marginLeft + 360, formY + 22);
            doc.text(`I authorize TAB Bank to verify this information by any means, including but not limited to preparation of my credit
      report by a credit reporting agency.`, marginLeft + 30, formY + 31);
      }
          
      formY += 41;
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY, maxWidth, 1, "F");
      doc.setFillColor(146,208,80);
      doc.rect(marginLeft, formY + 1, maxWidth, 11, "F");
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 11, maxWidth, 1, "F");
      doc.setFont('Helvetica', '', 'bold');
      doc.setFontSize(8)
      doc.text("[E] INDIVIDUAL WITH CONTROL INFORMATION", marginLeft + 2, formY + 9.5);
      //doc.setFont('Helvetica', 'italic', 'bold');
      //doc.text(` If "Yes" was NOT selected above in section A, B, C, or D please complete section E`, marginLeft + 190, formY + 9.5);
      doc.setFontSize(6.5)
      doc.setFont('Helvetica', '', 'bold');
      doc.setFillColor(146,208,80);
      doc.rect(marginLeft, formY + 12, maxWidth, 25, "F");
      doc.text(`The following information is for one individual with significant responsibility for managing the legal entity listed above such as: An executive officer or senior
manager (e.g., Chief Executive Officer, Chief Financial Officer, Chief Operating Officer, Managing Member, General Partner, President, Vice President, Treasurer);
or Any other individual who regularly performs similar functions. (If appropriate, an individual above in section A, B, C, or D may also be listed in the section E).`, marginLeft + 1, formY + 18.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 36, maxWidth, 1, "F");

      formY += 37;
      doc.setFontSize(7.5);
      doc.setFont('Helvetica', '', 'normal');
      doc.text("Individual Name:", marginLeft + 2, formY + 9.5);
      doc.text(`${checkData(control_owner?.first_name) +` `+ checkData(control_owner?.last_name)}`, marginLeft + 65, formY + 9.5);
      doc.text("Title:", marginLeft + 280, formY + 9.5);
      doc.text(`${checkData(control_owner?.title)}`, marginLeft + 302, formY + 9.5);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 11, maxWidth, 1, "F");
      doc.text("Street Address:", marginLeft + 2, formY + 21);
      doc.text(`${checkData(control_owner?.phys_address1)}`, marginLeft + 62, formY + 21);
      doc.text("City:", marginLeft + 230, formY + 21);
      doc.text(`${checkData(control_owner?.phys_city)}`, marginLeft + 250, formY + 21);
      doc.text("State:", marginLeft + 342, formY + 21);
      doc.text(`${checkData(control_owner?.phys_state)}`, marginLeft + 367, formY + 21);
      doc.text("Zip:", marginLeft + 432, formY + 21);
      doc.text(`${checkData(control_owner?.phys_zipcode)}`, marginLeft + 449, formY + 21);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 22, maxWidth, 1, "F");
      doc.text("Date of Birth:", marginLeft + 2, formY + 32);
      doc.text(`${control_owner?.date_of_birth != undefined ? moment(control_owner?.date_of_birth).format('MM/DD/YYYY') : ""}`, marginLeft + 50, formY + 32);
      doc.text("Social Secruity Number:", marginLeft + 260, formY + 32);
      doc.text(`${checkData(control_owner?.ssn)}`, marginLeft + 347, formY + 32);
      doc.setFillColor(0, 0, 0);
      doc.rect(marginLeft, formY + 33, maxWidth, 1, "F");
      doc.text("I,", marginLeft + 2, formY + 43);
      doc.text(`${checkData(control_owner?.first_name) +` `+ checkData(control_owner?.last_name)}`, marginLeft + 15, formY + 42);
      doc.rect(marginLeft + 7, formY + 43, 148, 0.5, "F");
      doc.text(`hereby certify, to the best of my knowledge that the information provided above is complete and correct.`, marginLeft + 155, formY + 43);
      doc.text(`The above information for each individual, if any, who directly or indirectly, through any contract, arrangement, understanding, relationship or otherwise,
owns 25 percent or more of the equity interests of the legal entity listed.`, marginLeft + 2, formY + 51);
          
      formY += 65;
      doc.setFontSize(7.5);
      doc.setFont('Helvetica', '', 'bold');
      doc.text("Applicant:", marginLeft + 2, formY + 10);
      doc.text("Co-Applicant:", marginLeft + 255, formY + 10);
      //doc.rect(marginLeft, formY + 11, maxWidth, 1, "F");
      doc.text("Signature:", marginLeft + 2, formY + 25);
      doc.text("Date:", marginLeft + 165, formY + 25);
      doc.text("Signature:", marginLeft + 255, formY + 25);
      doc.text("Date:", marginLeft + 440, formY + 25);
      doc.rect(marginLeft, formY + 26, 240, 1, "F");
      doc.rect(marginLeft + 253, formY + 26, 257, 1, "F");
      doc.text("Name:", marginLeft + 2, formY + 40);
      doc.text("Name:", marginLeft + 255, formY + 40);
      doc.rect(marginLeft, formY + 41, 240, 1, "F");
      doc.rect(marginLeft + 253, formY + 41, 257, 1, "F");
      doc.text("Title:", marginLeft + 2, formY + 55);
      doc.text("Title:", marginLeft + 255, formY + 55);
      doc.rect(marginLeft, formY + 56, 240, 1, "F");
      doc.rect(marginLeft + 253, formY + 56, 257, 1, "F");
      
    /* doc.setFont('Helvetica', '', 'normal');
    let formY = 380;
    doc.line(marginLeft, formY, marginLeft + 200, formY);
    doc.text("Name of Bank", marginLeft, formY + 20);
    doc.line(marginLeft + 250, formY, marginLeft + 450, formY);
    doc.text("Account #", marginLeft + 250, formY + 20); */

    const url = doc.output("blob");
    setPDFURL(doc.output("bloburi"));
    setPdfBlob(url);
    }
  //console.log(applicantDetails);
  return (
    <Grid container minHeight={500} columnSpacing={{ xs: 2, sm: 3, md: 4 }} sx={{ color: "#424446" }}>
      {/* <div><pre>{ JSON.stringify(applicantDetails, null, 2) }</pre></div> */}
      <Grid textAlign="left" container item xs={12}>
        <Typography variant="h5" gutterBottom component="div">
          Let's Review Your Information Before Submitting
        </Typography>
      </Grid>
      <Grid textAlign="left" container item xs={12}>
        <Grid textAlign="left" item xs={12} marginTop={3}>
          <Typography variant="h6" marginTop={1} gutterBottom component="div" borderBottom={"2px solid #757779"} color={'#0ea723'}>
            Basic Information
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500}>
            Legit Entity:
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
            {(legitEntityArr.find(obj => {
              return obj.code === applicantDetails?.legit_entity
            }))?.name}
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500}>
            Tax ID:
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
            {applicantDetails?.ein}
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500}>
            Company Name:
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
            {applicantDetails?.business_name}
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500}>
            Doing Business As:
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
            {applicantDetails?.dba}
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500}>
            Email Address:
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
            {applicantDetails?.email}
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500}>
            Mobile:
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
            {applicantDetails?.mobile}
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500}>
            Business Phone:
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
            {applicantDetails?.phone}
          </Typography>
        </Grid>
      </Grid>
      <Grid textAlign="left" container justifyContent="flex-start" item xs={12}>
        <Grid textAlign="left" item xs={12} marginTop={3}>
          <Typography variant="h6" marginTop={4} gutterBottom component="div" borderBottom={"2px solid #757779"} color={'#0ea723'}>
            Business Information
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500}>
            Address:
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
            {applicantDetails?.address1}
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500}>
            City:
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
            {applicantDetails?.city}
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500}>
            State:
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
            {applicantDetails?.state}
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500}>
            Zip Code:
          </Typography>
        </Grid>
        <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
          <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
            {applicantDetails?.zipcode}
          </Typography>
        </Grid>
      </Grid>

      <Grid textAlign="left" item xs={12} marginTop={3}>
        <Typography variant="h6" marginTop={4} gutterBottom component="div" borderBottom={"2px solid #757779"} color={'#0ea723'}>
          Trucking Information
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6} marginTop={1}>
        <Typography variant="subtitle2" fontWeight={500}>
          This Business is involved in the transportation/trucking industry?
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6} marginTop={1}>
        <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
          {applicantDetails?.is_transportation?.toString() == 'false' ? ('No') : ('Yes')}
        </Typography>
      </Grid>
      {applicantDetails?.is_transportation === 'true' &&
        <>
          <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
            <Typography variant="subtitle2" fontWeight={500}>
              Have you ever financed a truck/trailer?
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.is_financed.toString() == 'false' ? ('No') : ('Yes')}
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
            <Typography variant="subtitle2" fontWeight={500}>
              Is this purchase a
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.is_purchase.toString() == 'replacement' ? ('Replacement') : ('Addition')}
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
            <Typography variant="subtitle2" fontWeight={500}>
              Do you run under your own MC Authority?
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.isMcAuthority.toString() == 'false' ? ('No') : ('Yes')}
            </Typography>
          </Grid>
          {applicantDetails?.isMcAuthority === 'true' &&
            <>
            <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
              <Typography variant="subtitle2" fontWeight={500}>
                Are you currently factoring or financing your accounts receivable?
              </Typography>
            </Grid>
            <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
              <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                {applicantDetails?.currently_factoring.toString() == 'false' ? ('No') : ('Yes')}
              </Typography>
            </Grid>
            <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
              <Typography variant="subtitle2" fontWeight={500}>
                Fleet Size:
              </Typography>
            </Grid>
            <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
              <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                {applicantDetails?.fleet_size}
              </Typography>
            </Grid>
            <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
              <Typography variant="subtitle2" fontWeight={500}>
                Number of Trucks:
              </Typography>
            </Grid>
            <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
              <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                {applicantDetails?.number_of_trucks}
              </Typography>
            </Grid>
            <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
              <Typography variant="subtitle2" fontWeight={500}>
                Number of Trailers:
              </Typography>
            </Grid>
            <Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
              <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                {applicantDetails?.number_of_trailers}
              </Typography>
            </Grid>
          </>
          }
        </>
      }
      <Grid textAlign="left" item xs={6} marginTop={3}>
        <Typography variant="subtitle2" fontWeight={500}>
          Year Established:
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={6} marginTop={3}>
        <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
        <Moment format="YYYY" date={applicantDetails?.year_established} />
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={6} marginTop={1}>
        <Typography variant="subtitle2" fontWeight={500}>
          Business State:
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={6} marginTop={1} >
        <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
          {applicantDetails?.business_state}
        </Typography>
      </Grid>

      {
        applicantDetails?.factoring_with ? (
          <><Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
            <Typography variant="subtitle2" fontWeight={500}>
              Company you are Factoring with?
            </Typography>
          </Grid><Grid textAlign="left" item xs={12} md={6} lg={6} xl={6}>
              <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                {applicantDetails?.factoring_with}
              </Typography>
            </Grid></>
        ) : (
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
            </Typography>
          </Grid>
        )
      }
      <Grid textAlign="left" item xs={12} marginTop={3}>
        <Typography variant="h6" marginTop={4} gutterBottom component="div" borderBottom={"2px solid #757779"} color={'#0ea723'}>
          Other Information
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={6} marginTop={1}>
        <Typography variant="subtitle2" fontWeight={500}>
          Is business involved in Internet Gambling ?
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={6} marginTop={1}>
        <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
          {applicantDetails?.is_gambling == 'false' ? ('No') : ('Yes')}
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={6} marginTop={1}>
        <Typography variant="subtitle2" fontWeight={500}>
          Is business a Money Services Business?
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={6} marginTop={1}>
        <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
          {applicantDetails?.is_money_service?.toString() == 'false' ? ('No') : ('Yes')}
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={6} marginTop={1}>
        <Typography variant="subtitle2" fontWeight={500}>
          Is any company officer, applicant, cardholder (driver) or guarantor a politically exposed person?
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={6} marginTop={1}>
        <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
          {applicantDetails?.politically_exposed == 'false' ? ('No') : ('Yes')}
        </Typography>
      </Grid>
      {applicantDetails?.helped_by &&
        <>
          <Grid textAlign="left" item xs={6} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500}>
              How did you hear about us?
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={6} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.helped_by}
            </Typography>
          </Grid>
        </>
      }
      <Grid textAlign="left" item xs={12}>
        <Typography variant="h6" marginTop={4} gutterBottom component="div" borderBottom={"2px solid #757779"} color={'#0ea723'}>
          Owners
        </Typography>
      </Grid>
      {/* Owners */}
      {applicantDetails?.owners?.map((owner, index) => (
        <Grid item xs={12} marginBottom={1} columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
          <Accordion sx={{ width: 1 }}>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography sx={{ textTransform: 'capitalize' }} color={'primary'} variant="subtitle2" fontWeight={500}><b style={{ color: "#0ea723" }}>Owner {index + 1}</b> {owner?.first_name} {owner?.middle_name} {owner?.last_name} - ({owner?.ownership_percent}%)</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ width: 1 }}>
              <Grid container item xs={12} columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    First Name:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.first_name}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Middle Name:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.middle_name}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Last Name:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.last_name}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Email Address:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.email}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Mobile:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.mobile_phone}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Home Phone:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.home_phone}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Date of Birth:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    <Moment format="MM/DD/YYYY" date={owner?.date_of_birth} />
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    SSN:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.ssn}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Title:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.title}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Ownership %:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.ownership_percent}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Years Driving:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.years_driving}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12}>
                  <Typography variant="subtitle2" marginTop={4} fontWeight={500} borderBottom={'1px solid'}>
                    Physical Address
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Address:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.phys_address1}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    City:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.phys_city}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    State:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.phys_state}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Zip Code:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.phys_zipcode}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12}>
                  <Typography variant="subtitle2" marginTop={4} fontWeight={500} borderBottom={'1px solid'}>
                    Mailing Address
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Address:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.mail_address1}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    City:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.mail_city}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    State:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.mail_state}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Zip Code:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.mail_zipcode}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12}>
                  <Typography variant="subtitle2" marginTop={4} fontWeight={500} borderBottom={'1px solid'}>
                    Garaging Address
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Address:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.garage_address1}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    City:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.garage_city}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    State:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.garage_state}
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Zip Code:
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.garage_zipcode}
                  </Typography>
                </Grid>
                {/* <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Is any company officer, applicant, cardholder (driver) or guarantor a politically exposed person?
                  </Typography>
                </Grid>
                <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
                  <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                    {owner?.politically_exposed == 'false' ? ('No') : ('Yes')}
                  </Typography>
                </Grid> */}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
      ))}
      
        <>
          <Grid textAlign="left" item xs={12} marginTop={3}>
            <Typography variant="h6" marginTop={4} gutterBottom component="div" borderBottom={"2px solid #757779"} color={'#0ea723'}>
              Hauling Reference
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500}>
              Truck to haul for:
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.truck_to_haul_for}
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500}>
              New Contract:
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.new_lease === 'true' ? 'Yes' : 'No'}
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500}>
              Contact Person:
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.contact_person}
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500}>
              Business Phone:
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.hauling_phone}
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500}>
              Address:
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.hauling_address}
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500}>
              City:
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.hauling_city}
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500}>
              State:
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.hauling_state}
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500}>
              Zip Code:
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.hauling_zipcode}
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500}>
              Monthly Gross Income:
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {formatNumberWithCommas(applicantDetails?.monthly_gross_income,true)}
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500}>
              Years with the company:
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.years_with_company}
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500}>
              Commodity Hauled:
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {applicantDetails?.commodity_hauled}
            </Typography>
          </Grid>
          <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
              <Typography variant="subtitle2" fontWeight={500}>
                MC#:
              </Typography>
            </Grid>
            <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
              <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                {applicantDetails?.mc}
              </Typography>
            </Grid>
        </>
      
      <>
        <Grid textAlign="left" item xs={12} marginTop={3}>
          <Typography variant="h6" marginTop={4} gutterBottom component="div" borderBottom={"2px solid #757779"} color={'#0ea723'}>
            Equipment
          </Typography>
        </Grid>
        {applicantDetails?.equipments?.map((equipment, index) => (
          <>
            <Grid textAlign="left" item xs={12}>
              <Typography variant="h7" marginTop={1} gutterBottom component="div" borderBottom={"2px dotted #0ea723"} color={'#0ea723'} paddingBottom={"5px"} fontWeight={"700"}>
                Equipment - { index + 1 }
              </Typography>
            </Grid>
            <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
              <Typography variant="subtitle2" fontWeight={500}>
                Type:
              </Typography>
            </Grid>
            <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
              <Typography variant="subtitle2" fontWeight={500} color={'primary'} textTransform={"capitalize"}>
                {equipment?.equip_type}
              </Typography>
            </Grid>
            <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
              <Typography variant="subtitle2" fontWeight={500}>
                Invoice Amount:
              </Typography>
            </Grid>
            <Grid textAlign="left" item xs={12} md={3} lg={3} xl={3} marginTop={1}>
              <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
                {formatNumberWithCommas(equipment?.equip_inv_amount,true)}
              </Typography>
            </Grid>
          </>
        ))}
      </>
      <Grid textAlign="left" item xs={12}>
        <Typography variant="h6" marginTop={4} gutterBottom component="div" borderBottom={"2px solid #757779"} color={'#0ea723'}>
          Documents
        </Typography>
        <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
          {/* Operating Agreement:  {OperatingAgreementFile} */}
          <br />
          {AdditionalInvoiceFilesConf &&
            <>
              <Card>
                <CardContent>
                  <b style={{ color: "#424446" }}>Invoice:</b>
                  {AdditionalInvoiceFilesConf?.map((AdditionalInvoiceFile) => (
                    <div>
                      {AdditionalInvoiceFile?.filename}
                      {AdditionalInvoiceFile?.filename.split(".").pop().toLowerCase() == "pdf" &&
                        <Button onClick={() => handleOpenAF(AdditionalInvoiceFile)} startIcon={<Visibility />}></Button>
                      }
                    </div>
                  ))
                  }
                </CardContent>
              </Card>
              <br />
            </>
          }
          {AdditionalVSFilesConf &&
            <>
              <Card>
                <CardContent>
                  <b style={{ color: "#424446" }}>Vehicle Specifications:</b>
                  {AdditionalVSFilesConf?.map((AdditionalVSFile) => (
                    <div>
                      {AdditionalVSFile?.filename}
                      {AdditionalVSFile?.filename.split(".").pop().toLowerCase() == "pdf" &&
                        <Button onClick={() => handleOpenAF(AdditionalVSFile)} startIcon={<Visibility />}></Button>
                      }
                    </div>
                  ))
                  }
                </CardContent>
              </Card>
              <br />
            </>
          }
          {AdditionalDLFilesConf &&
            <>
              <Card>
                <CardContent>
                  <b style={{ color: "#424446" }}>Drivers License:</b>
                  {AdditionalDLFilesConf?.map((AdditionalDLFile) => (
                    <div>
                      {AdditionalDLFile?.filename}
                      {AdditionalDLFile?.filename.split(".").pop().toLowerCase() == "pdf" &&
                        <Button onClick={() => handleOpenAF(AdditionalDLFile)} startIcon={<Visibility />}></Button>
                      }
                    </div>
                  ))
                  }
                </CardContent>
              </Card>
              <br />
            </>
          }
          {AdditionalDocsFilesConf &&
            <>
              <Card>
                <CardContent>
                  <b style={{ color: "#424446" }}>Other:</b>
                  {AdditionalDocsFilesConf?.map((AdditionalDocsFile) => (
                    <div>
                      {AdditionalDocsFile?.filename}
                      {AdditionalDocsFile?.filename.split(".").pop().toLowerCase() == "pdf" &&
                        <Button onClick={() => handleOpenAF(AdditionalDocsFile)} startIcon={<Visibility />}></Button>
                      }
                    </div>
                  ))
                  }
                </CardContent>
              </Card>
              <br />
            </>
          }
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={12}>
        <Typography variant="h6" marginTop={4} gutterBottom component="div" borderBottom={"2px solid #757779"} color={'#0ea723'}>
          Agreements
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={6}>
        <Typography variant="subtitle2" fontWeight={500}>
          Electronic Communications Disclosure
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={6}>
        <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
          {applicantDetails?.electronic_communications_disclosure.toString() == 'false' ? ('No') : ('Agreed')}
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={12}>
        <Typography variant="h6" marginTop={4} gutterBottom component="div" borderBottom={"2px solid #757779"} color={'#0ea723'}>
          PDF Form
        </Typography>
      </Grid>
      <Grid textAlign="left" item xs={6}>
        <Typography variant="subtitle2" fontWeight={500}>
          {/* <ModalPDF applicantDetails={applicantDetails} onGeneratePDF={handleGeneratePDF} /> */}
          <Button onClick={handleOpenApplicantForm}>VIEW PDF FORM</Button>
        </Typography>
      </Grid>
      <Grid marginTop={4} container xs={12} sx={{ display: { xs: 'block', sm: 'none' } }}>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <StepButtons updateInfo={onUpdateDocumentsInfo} nextBtn={false} ref={ref} />
        </Grid>
        <Grid marginTop="20px" item xs={12}>
          <Button style={{ width: '200px' }} variant="contained" onClick={handleOpenConfirm}>Confirm</Button>
        </Grid>
      </Grid>
      <Grid xs={12} sx={{ display: { xs: 'none', sm: 'block' } }} paddingLeft={'32px'}>
        <Grid marginTop={4} container item xs={12}>
          <Grid textAlign="left" item xs={6}><StepButtons updateInfo={onUpdateDocumentsInfo} nextBtn={false} /></Grid>
          <Grid textAlign="right" marginTop="50px" item xs={6}>
            <Button style={{ width: '200px' }} variant="contained" onClick={handleOpenConfirm}>Confirm</Button>
          </Grid>
        </Grid>
      </Grid>
      <Modal
        open={openOAF}
        onClose={handleCloseOAF}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className='pdf-container'>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {'Invoice'} - {OperatingAgreementFile}
            </Typography>
            <br />
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.14.305/build/pdf.worker.min.js">
              <Viewer fileUrl={applicantDetails?.operating_agreement_file}
                plugins={[defaultLayoutPluginInstance]} />
            </Worker>
          </div>
        </Box>
      </Modal>
      <Modal
        open={openFinancials}
        onClose={handleCloseFinancials}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className='pdf-container'>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {'Vehicle Specification'} - {FinancialFile}
            </Typography>
            <br />
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.14.305/build/pdf.worker.min.js">
              <Viewer fileUrl={applicantDetails?.financials_file}
                plugins={[defaultLayoutPluginInstance]} />
            </Worker>
          </div>
        </Box>
      </Modal>
      <Modal
        open={openOAR}
        onClose={handleCloseOAR}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className='pdf-container'>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {'Drivers License'} - {OpenARFile}
            </Typography>
            <br />
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.14.305/build/pdf.worker.min.js">
              <Viewer fileUrl={applicantDetails?.open_ar_file}
                plugins={[defaultLayoutPluginInstance]} />
            </Worker>
          </div>
        </Box>
      </Modal>
      <Modal
        open={openAF}
        onClose={handleCloseAF}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className='pdf-container'>
            <Typography variant="subtitle2" fontWeight={500} color={'primary'}>
              {'Other'} - {fileName}
            </Typography>
            <br />
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.14.305/build/pdf.worker.min.js">
              <Viewer fileUrl={fileData}
                plugins={[defaultLayoutPluginInstance]} />
            </Worker>
          </div>
        </Box>
      </Modal>
            <Dialog
                open={openApplicantForm}
                onClose={handleCloseApplicantForm}
                fullWidth='true'
                maxWidth='xl'
                scroll='body'
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle>
                    <Toolbar>
                        <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleCloseApplicantForm}
                        aria-label="close"
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: 'black',
                            }}
                        >
                            <Close />
                        </IconButton>
                        <Typography>
                            APPLICATION FORM
                        </Typography>
                    </Toolbar>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Grid container columnSpacing={{ xs: 2, sm: 4 }}>
                            <Grid item xs={12}>
                                <Box fullWidth xs={12} className='mt-4'>
                                  <div className='pdf-container'>
                                      <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.14.305/build/pdf.worker.min.js">
                                      <Viewer fileUrl={PDFURL}
                                          plugins={[defaultLayoutPluginInstance]}
                                          defaultScale={2} />
                                      </Worker>
                                  </div>
                                </Box>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
      <Modal
        open={openConfirm}
        onClose={handleClosConfirm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={matches ? style : style2}>
          {matches ? (
            <Grid container>
              <Grid item xs={6}>
                <Typography id="modal-modal-description" variant="h6" sx={{ mt: 3 }}>
                  Legal and Compliance
                </Typography>
              </Grid>
              <Grid item xs={6} textAlign={'end'}>
                <img src={logo} />
              </Grid>
            </Grid>
          ) : (
            <Grid container>
              <Grid item xs={12} textAlign={'center'}>
                <img style={{ maxWidth: '70%' }} src={logo} />
              </Grid>
              <Grid item xs={12} textAlign={'center'}>
                <Typography variant="h6" sx={{ mt: 3 }}>
                  Legal and Compliance
                </Typography>
              </Grid>
            </Grid>
          )
          }
          <Grid container item columnSpacing={{ sm: 1, md: 1 }}>
            <Grid item sx={{ mt: 3 }}>
              <Typography color={"#616365"} variant="subtitle2" id="modal-modal-description">
                Under penalties of perjury, I,
              </Typography>
            </Grid>
            {matches ? (
              <Grid item xs={12} sm={7} sx={{ mt: 2.75 }}>
                <TextField
                  inputProps={{ style: { fontSize: 12 } }}
                  placeholder="Full Name"
                  name="fullNameConfirm"
                  fullWidth
                  onBlur={handleChecker}
                  error={!fullNameError}
                  variant="standard"
                  {...bindConfirmFullName}
                />
                {!fullNameError && <FormHelperText sx={{ color: '#D32F2F' }}>{'Name must match one of the owners.'}</FormHelperText>}

              </Grid>
            ) : (
              <Grid item xs={9}>
                <TextField
                  inputProps={{ style: { fontSize: 12 } }}
                  placeholder="Full Name"
                  name="fullNameConfirm"
                  fullWidth
                  onBlur={handleChecker}
                  error={!fullNameError}
                  variant="standard"
                  {...bindConfirmFullName}
                />
                {!fullNameError && <FormHelperText sx={{ color: '#D32F2F' }}>{'Name must match one of the owners.'}</FormHelperText>}
              </Grid>
            )
            }
            <Grid item variant="subtitle2" xs={12}>
              <Typography color={"#616365"} variant="subtitle2" id="modal-modal-description">
                hereby certify that :
              </Typography>
            </Grid>
          </Grid>
          {/* <Grid container sx={{ mt: 3 }}>
          </Grid> */}
          <Grid container sx={{ mt: 3 }}>
            <Grid item xs={7} sm={7}>
              <Typography color={"#616365"} variant="subtitle2" component="div">
                To the best of my knowledge that the information provided throughout this application is complete and correct.
              </Typography>
            </Grid>
            <Grid item xs={5} sm={5} >
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name='us_citizen'
                value={confirmFirst}
                required={true}
                sx={{ paddingLeft: '30px' }}
                {...bindConfirmFirst}
              >
                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                <FormControlLabel value="false" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
          </Grid>
          <Grid container sx={{ mt: 3 }}>
            <Grid item xs={7} sm={7}>
              <Typography color={"#616365"} variant="subtitle2" component="div">
                To the best of my knowledge all beneficial owners (those who make up 20% or more ownership in
                the company) as well as an “individual with control” have been entered under the owners section
                of the application.
              </Typography>
            </Grid>
            <Grid item xs={5} sm={5} >
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name='us_citizen'
                value={confirmSecond}
                required={true}
                sx={{ paddingLeft: '30px' }}
                {...bindConfirmSecond}
              >
                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                <FormControlLabel value="false" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
          </Grid>
          <Grid container sx={{ mt: 3 }}>
            <Grid item xs={12} sm={12}>
              <Typography component="div" variant="subtitle1">
                Legal Definition (Individual w/ control):
              </Typography>
              <Typography color={"#616365"} variant="subtitle2" component="div">
                • An executive officer or senior manager (e.g., Chief Executive Officer, Chief Financial Officer, Chief Operating Officer, Managing Member, General Partner, President, Vice President, Treasurer); or
                <br />
                • Any other individual who regularly performs similar functions.
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ mt: 4 }}>
            <Grid item xs={7} sm={7}>
              <Typography color={"#616365"} variant="subtitle2" component="div">
                All taxpayer identification numbers shown on this application are correct (or in the process
                of being issued)
              </Typography>
            </Grid>
            <Grid item xs={5} sm={5} >
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name='us_citizen'
                value={confirmThird}
                required={true}
                sx={{ paddingLeft: '30px' }}
                {...bindConfirmThird}
              >
                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                <FormControlLabel value="false" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
          </Grid>
          {/* <Grid container sx={{ mt: 3 }}>
            <Grid item xs={7} sm={7}>
              <Typography color={"#616365"} variant="subtitle2" component="div">
                And that the company and all owners are <i>NOT</i> subject to backup withholding either because;
                <br />
                <i>(a) </i>They are exempt from backup withholding, or
                <br />
                <i>(b) </i>They have not been notified by the Internal Revenue Service (IRS) that  they are subject to backup withholdings as a result of a failure to report all interest or dividends, or
                <br />
                <i>(c) </i>the IRS has notified them that they are no longer subject to backup withholding
              </Typography>
            </Grid>
            <Grid item xs={5} sm={5} >
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name='us_citizen'
                value={confirmFourth}
                required={true}
                sx={{ paddingLeft: '30px' }}
                {...bindConfirmFourth}
              >
                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                <FormControlLabel value="false" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
          </Grid> */}
          {/* <Grid container sx={{ mt: 3 }}>
            <Grid item xs={7} sm={7}>
              <Typography color={"#616365"} variant="subtitle2" component="div">
                <b>Due Diligence Disclosure: </b>
                <br />
                By submitting this application, Applicant acknowledges they will be required to pay Transportation Alliance Bank, Inc. d/b/a TAB Bank
                (TAB) a non-refundable due diligence fee equal to two hundred fifty dollars ($250.00) from the initial funding, to begin the credit
                review process. Additionally, the applicant acknowledges the due diligence fee will remain due and payable to TAB in the event the
                fee is not collected from the initial funding for any reason.
              </Typography>
            </Grid>
            <Grid item xs={5} sm={5}>
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name='us_citizen'
                value={confirmSixth}
                required={true}
                sx={{ paddingLeft: '30px' }}
                {...bindConfirmSixth}
              >
                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                <FormControlLabel value="false" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
          </Grid> */}
          <Grid container sx={{ mt: 3 }}>
            <Grid item xs={7} sm={7}>
              <Typography color={"#616365"} variant="subtitle2" component="div">
                <b>Application Disclosure: </b>
                <br />
                <b>By submitting this application, you authorize TAB Bank to obtain credit reports and other information about you from consumer reporting agencies for the purpose of evaluating your creditworthiness and for any other lawful purpose.</b> By applying for any service, you agree that this application contains provisions that apply to any and all services that we provide to you, and it contains provisions that apply to specific services including, but not limited to, Equipment Financing. Your use of any service also evidences your agreement to be bound to the applicable terms and conditions of each.
              </Typography>
            </Grid>
            <Grid item xs={5} sm={5} >
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name='us_citizen'
                value={confirmFifth}
                required={true}
                sx={{ paddingLeft: '30px' }}
                {...bindConfirmFifth}
              >
                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                <FormControlLabel value="false" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
          </Grid>

          <Grid container direction="column" spacing={2}>
            <Grid item xs={12} marginTop={6} textAlign={'center'}>
              <ButtonGroup variant="contained" aria-label="outlined primary button group" style={{ width: '200px' }}>
                <Button onClick={handleClosConfirm} sx={{ background: '#d3d3d3' }} fullWidth>Cancel</Button>
                <Button
                  disabled={
                    /* (confirmFullName == '') ||
                    (confirmFirst != 'true') ||
                    (confirmSecond != 'true') ||
                    (confirmThird != 'true') ||
                    //(confirmFourth != 'true') ||
                    (confirmFifth != 'true') ||
                    //(confirmSixth != 'true') || */
                    !fullNameError
                  }
                  fullWidth onClick={createNewApplicant}>Apply</Button>
              </ButtonGroup>
            </Grid>
          </Grid>
        </Box>
      </Modal>

    </Grid>
  )
}

export default forwardRef(Confirmation)